import React, { useEffect, useMemo, useState } from 'react';
import ReactDOM from 'react-dom';
import { Button, Col } from 'antd';
import Typography from 'antd/es/typography';
import CloseOutlined from '@ant-design/icons/CloseOutlined';
import { getCurrentLang } from 'common/helpers/i18n';
import { ReactComponent as HeaderAchievementIcon } from 'app/assets/images/header-achievement.svg';

const STORAGE_KEY = 'promoHeaderClosed';

export const HeaderAchievement = () => {
  const [visible, setVisible] = useState(false);
  const lang = getCurrentLang();
  const isLangRu = useMemo(() => lang === 'ru', [lang]);
  useEffect(() => {
    const isClosed = localStorage.getItem(STORAGE_KEY) === 'true';
    if (!isClosed) {
      setVisible(true);
    }
  }, []);

  useEffect(() => {
    const rootElement = document.getElementById('root');
    if (visible && rootElement) {
      visible ? rootElement.classList.add('position-relative') : rootElement.classList.add('position-unset');
    }
  }, [visible]);

  const handleClose = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    setVisible(false);
  };

  const container = document.getElementById('header-achievement-container');
  if (!visible || !container || !lang) {
    return null;
  }

  return ReactDOM.createPortal(
    <a
      href={
        isLangRu
          ? 'https://www.sports.ru/football/blogs/3302868.html'
          : 'https://medium.com/@junistat/junistat-named-a-finalist-in-the-barça-innovation-hub-da329d2aa128'
      }
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className="header__achievement">
        <div className="header__achievement_content">
          <span className="header__achievement_text">{isLangRu ? 'ТОП 5 стартапов 2025' : 'TOP 5 startups 2025'}</span>
          <HeaderAchievementIcon />
        </div>
        <Col>
          <Button
            className="ml-2"
            shape="circle"
            type="text"
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
              handleClose();
            }}
          >
            <Typography.Text>
              <CloseOutlined className="fs-xs color-black" />
            </Typography.Text>
          </Button>
        </Col>
      </div>
    </a>,
    container
  );
};
